import {Button, Group, Modal} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import {useCallback, useEffect} from 'react';
import {AddPlayerButton} from './AddPlayerButton';
import {AssignPlayersPanel} from './AssignPlayersPanel';
import {LinkConsentModal} from './LinkConsentModal';
import {LinkCreationButton} from './LinkCreationButton';
import {useActiveEditMode, useClearActiveEdit, useIsLinkCreationActive} from '../state/networkEditStore';

export function DesignModeOptions() {
    const [opened, {open, close}] = useDisclosure(false);
    const editMode = useActiveEditMode();
    const isLinkCreationActive = useIsLinkCreationActive();
    const clearActiveEdit = useClearActiveEdit();

    const handleEscape = useCallback((event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            clearActiveEdit();
        } 
    }, [clearActiveEdit]);

    useEffect(() => {
        if (isLinkCreationActive || editMode === 'addPlayer') {
            document.addEventListener('keydown', handleEscape);
        }
        return () => document.removeEventListener('keydown', handleEscape);
    }, [editMode, handleEscape]);

    return <>
        <Modal opened={opened} onClose={close} size={'50%'} centered withCloseButton={false}
            overlayProps={{backgroundOpacity: 0.55, blur: 3}}>
            <AssignPlayersPanel onClose={close}/>
        </Modal>
        <Group 
            grow justify='center'
            style={{
                position: 'absolute', bottom: '8%', left: '21.25%', width: '35%',
            }}>
            <LinkCreationButton/>
            <AddPlayerButton/>
            {/* Start game */}
            <Button style={{pointerEvents: 'all'}} color="red" onClick={open}>Validate and publish</Button>
        </Group>
        <LinkConsentModal />
    </>;
}
